import React, { useEffect, useRef, useState } from "react";
import "./ChatWithCode.css";
import CodeEditor from "../CodeEditor/CodeEditer";
// import cwc from '../../../static/cwc.jpg'?
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal'

import { BounceLoader } from "react-spinners";
const [minWidth, maxWidth, defaultWidth] = [30, 80, 35];
const ChatWithCode = (props) => {
    const [chatType, setChatType] = React.useState("ExplainAndDebug");
    const [width, setWidth] = React.useState(defaultWidth);
    const { modifyChatHistory, cwcIndex, modifyJupyterNotebook, cwcCellHistory, clearChatHistory, ChangeCwcView, debugCellOutput, setDebugCellOutput } = props;
    const [localChat, setLocalChat] = React.useState(cwcCellHistory);
    const [input, setInput] = React.useState("");
    const [gptModal, setGptModal] = useState("gpt-3.5-turbo")
    const chatBoxRef = useRef(null);
    const inputRef = useRef(null);

    // system prompt
    const [showModal, setShowModal] = useState(false);
    const [systemPrompt, setSystemPrompt] = useState("");
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);
    // Function to scroll the chatbox to the bottom
    const scrollToBottom = async () => {
        await new Promise(resolve => setTimeout(resolve, 200)); // wait for 1 second
        if (chatBoxRef && chatBoxRef.current) {
            chatBoxRef.current.scrollTo({
                top: chatBoxRef.current.scrollHeight,
                behavior: 'smooth' // Smooth scrolling behavior
            });
        }
    };
    const adjustInputHeight = () => {
        const input = inputRef.current;
        input.style.height = 'auto';
        input.style.height = `${input.scrollHeight}px`;
    };
    const onChangeChatCode = (cellCode, index) => {
        setLocalChat(prevChat => {
            const tempChat = { ...prevChat };
            if (tempChat.chat && tempChat.chat[index]) {
                tempChat.chat[index] = { ...tempChat.chat[index], message: cellCode };
            }
            modifyChatHistory(cwcIndex, tempChat);
            return tempChat;
        });
    };
    const onChangeDebugChatCode = (cellCode, index) => {
        setLocalChat(prevChat => {
            const tempChat = { ...prevChat };
            if (tempChat.debug && tempChat.debug[index]) {
                tempChat.debug[index] = { ...tempChat.debug[index], message: cellCode };
            }
            modifyChatHistory(cwcIndex, tempChat);
            return tempChat;
        });
    };
    const copyCode = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            // alert('Text copied');
            toast.success('Code Copied!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                // transition: Bounce,
            });
        } catch (error) {
            toast.error(error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                // transition: Bounce,
            });
        }
        // toast("Code Copied!");
    }
    const AddChat = (type, isCode, message) => {
        let tempChat = { ...localChat };
        if (tempChat.chat) {
            tempChat.chat.push({ type: type, isCode: isCode, message: message });
        }
        setLocalChat(tempChat);
        modifyChatHistory(cwcIndex, tempChat);
        scrollToBottom();
    }
    const AddDebugChat = (type, isCode, message) => {
        let tempChat = { ...localChat };
        if (tempChat?.debug) {
            tempChat.debug.push({ type: type, isCode: isCode, message: message });
        }
        setLocalChat(tempChat);
        modifyChatHistory(cwcIndex, tempChat);
        scrollToBottom();
    }
    const SetLoading = (value) => {
        const tempChat = { ...localChat }
        tempChat.isLoading = value;
        setLocalChat(tempChat)
        modifyChatHistory(cwcIndex, tempChat);

    }
    const last10chats = (chat) => {
        const len = chat.length;
        let retvalue = "";
        for (let i = len - 1; i >= 0 && i >= len - 11; i--) {
            if (i === len - 1 && !chat[i].isCode) {
                continue;
            }
            retvalue = chat[i].message + "\n\n" + retvalue;
        }
        return retvalue;
    }
    const ExplainAndDebugAPI_ = async (cwcIndex, value, gptModal) => {
        SetLoading(true);
        try {
            const url = "https://workable-ai-ml-1.onrender.com/debug-code"
            const payload = {
                "context": last10chats(localChat?.debug),
                "user_query": value,
                "secret": "abcdefgh567635@#%!&",
                "model": gptModal,
                "system_prompt": systemPrompt,
            }
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }

            const response = await fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(payload)
            })
            if (response.ok) {
                const data = await response.json();
                if (data && data.code)
                    data.code.map((value) => {
                        if (value && value.type && value.value) {
                            AddDebugChat("incoming", value.type === "code", value.value);
                        } else { console.log("Some error occured") }
                    })
            } else { console.error("reponse not ok") }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            SetLoading(false);
        }
    }
    const ChatWithCodeapi_ = async (cwcIndex, value, gptModal) => {
        SetLoading(true);
        try {
            const url = "https://workable-ai-ml-1.onrender.com/chat-code";
            const payload = {
                // context: lastcodeinChat(localChat.chat),
                context: last10chats(localChat.chat),
                user_query: value,
                secret: "abcdefgh567635@#%!&",
                model: gptModal,
            };
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Access-Control-Allow-Origin": "*",
                },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const data = await response.json();
                if (data && data.code)
                    data.code.map((value) => {
                        if (value && value.type && value.value && value.type === "code") {
                            AddChat("incoming", true, value.value);
                        } else { console.log("Some error occured") }
                    })
            } else { console.error("reponse not ok") }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        } finally {
            SetLoading(false);
        }
    }
    const onSend = () => {
        if (input === "") {
            alert("Error: input is empty");
        }
        if (chatType !== "modifyCode") {
            AddDebugChat("outgoing", false, input);
            ExplainAndDebugAPI_(cwcIndex, input, gptModal);
            setInput("");
            setDebugCellOutput({});
        }
        else {
            AddChat("outgoing", false, input);
            ChatWithCodeapi_(cwcIndex, input, gptModal);
            setInput("");
        }

    }
    const handleKeyDown = (event) => {
        if (event.keyCode === 13 && !event.shiftKey) { //13 is enter
            event.preventDefault();
            // Trigger the button element with a click
            onSend();
        }
    }
    const DeleteChatHistory = (cwcIndex) => {
        clearChatHistory(cwcIndex);
    }
    useEffect(() => {
        adjustInputHeight();
    }, [input]);
    useEffect(() => {
        scrollToBottom();
    }, [localChat?.chat])
    useEffect(() => {
        setLocalChat(cwcCellHistory);
        setInput("");
        // if debugCellOutput is present
        if (debugCellOutput !== "") {
            setInput(debugCellOutput);
            setChatType("DebugAndExplain")
        }
        // ******************
        scrollToBottom();
    }, [props])
    const handler = (mouseDownEvent) => {
        const startWidth = width;
        const startPosition = { x: mouseDownEvent.pageX, y: mouseDownEvent.pageY };

        function onMouseMove(mouseMoveEvent) {
            let newWidth = startWidth + (startPosition.x - mouseMoveEvent.pageX) * 100 / window.innerWidth;
            if (newWidth < minWidth) newWidth = minWidth;
            if (newWidth > maxWidth) newWidth = maxWidth;
            setWidth(newWidth);
        }
        function onMouseUp() {
            document.body.removeEventListener("mousemove", onMouseMove);
            // uncomment the following line if not using `{ once: true }`
            document.body.removeEventListener("mouseup", onMouseUp);
        }

        document.body.addEventListener("mousemove", onMouseMove);
        document.body.addEventListener("mouseup", onMouseUp, { once: true });
    };
    function classNames(...args) {
        return args.filter(Boolean).join(' ')
    }
    return (
        <>
            <div style={{ display: "flex" }}>
                <div
                    style={{ width: "5px", cursor: "col-resize" }}
                    className="w-2 cursor-col-resize"
                    onMouseDown={handler}
                >
                </div>
                <div className="cwc-container" style={{ width: `${width}vw` }}>
                    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                        <div className="cwc-navbar">
                            {/* <img className="cwc-icon" src={cwc} alt="cwc" /> */}
                            <div className="cwc-navbar-select-div">
                                <select className="cwc-navbar-select-button" value={gptModal} onChange={(e) => { setGptModal(e.target.value); }}>
                                    <option value="gpt-3.5-turbo">GPT-3.5</option>
                                    <option value="gpt-4">GPT-4</option>
                                    {/* <option value="option3">Option 3</option> */}
                                </select>
                                <button className="cwc-navbar-system-button" onClick={handleShowModal}>
                                    <svg viewBox="0 0 16 16" width="1.2em" height="1.2em"><path fill="currentColor" d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86a2.929 2.929 0 0 1 0 5.858z"></path></svg>
                                </button>
                            </div>
                            <div className="cwc-navbar-toggle-div">

                                <div className="cwc-navbar-toggle-button">
                                    <button className={classNames("tablinks", chatType === 'modifyCode' && "active")} onClick={() => { setChatType("modifyCode") }} >Modify Code</button>
                                    <button className={classNames("tablinks", chatType !== 'modifyCode' && "active")} onClick={() => setChatType("ExplainAndDebug")}>Explain & Debug</button>
                                </div>
                            </div>
                            <div>
                                <button
                                    onClick={() => { DeleteChatHistory(cwcIndex) }}
                                    style={{ padding: "5px", margin: '0px 0px 0px 0', background: "none", cursor: "pointer" }}
                                    title="Delete Chat"
                                    disabled={localChat?.isLoading}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon-md"><path fillRule="evenodd" clipRule="evenodd" d="M10.5555 4C10.099 4 9.70052 4.30906 9.58693 4.75114L9.29382 5.8919H14.715L14.4219 4.75114C14.3083 4.30906 13.9098 4 13.4533 4H10.5555ZM16.7799 5.8919L16.3589 4.25342C16.0182 2.92719 14.8226 2 13.4533 2H10.5555C9.18616 2 7.99062 2.92719 7.64985 4.25342L7.22886 5.8919H4C3.44772 5.8919 3 6.33961 3 6.8919C3 7.44418 3.44772 7.8919 4 7.8919H4.10069L5.31544 19.3172C5.47763 20.8427 6.76455 22 8.29863 22H15.7014C17.2354 22 18.5224 20.8427 18.6846 19.3172L19.8993 7.8919H20C20.5523 7.8919 21 7.44418 21 6.8919C21 6.33961 20.5523 5.8919 20 5.8919H16.7799ZM17.888 7.8919H6.11196L7.30423 19.1057C7.3583 19.6142 7.78727 20 8.29863 20H15.7014C16.2127 20 16.6417 19.6142 16.6958 19.1057L17.888 7.8919ZM10 10C10.5523 10 11 10.4477 11 11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11C9 10.4477 9.44772 10 10 10ZM14 10C14.5523 10 15 10.4477 15 11V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V11C13 10.4477 13.4477 10 14 10Z" fill="#C92B00"></path></svg>
                                </button>
                                <button
                                    onClick={() => { ChangeCwcView(false); }}
                                    style={{ padding: "5px", margin: '0px 0px 0px 0', background: "none", cursor: "pointer" }}
                                    title="close"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="plain-icon-color stroke-[2]"><path d="M9 6l6 6l-6 6"></path></svg>
                                </button>
                            </div>
                        </div>
                        {chatType === "modifyCode" ?
                            <div className="cwc-chat custom-scrollbar" ref={chatBoxRef}>
                                {localChat.chat && localChat.chat.map((value, index) => {
                                    const chatClassname = "cwc-chat-message " + value.type;
                                    const isCelleditable = value.isCode;
                                    const setCode = (val) => { onChangeChatCode(val, index); }
                                    return (
                                        <div key={index} className={chatClassname} style={value.isCode ? { width: "75%" } : {}}>
                                            {!value.isCode ? value.message : <CodeEditor code={value.message} setCode={setCode} editable={isCelleditable} />}
                                            {isCelleditable && <>
                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                                    <button className="button-29" onClick={() => copyCode(value.message)}>Copy Code</button>
                                                    <button className="button-29" onClick={() => modifyJupyterNotebook(cwcIndex, value.message)}>Modify Selected Cell</button>
                                                </div>
                                            </>
                                            }
                                        </div>
                                    )
                                })}
                                {localChat?.isLoading && <div className="cwc-chat-message incoming" style={{ padding: '50px', background: "none" }}>
                                    <BounceLoader color="white" size={40} loading={localChat?.isLoading} />
                                </div>
                                }
                            </div> :
                            <div className="cwc-chat custom-scrollbar" ref={chatBoxRef}>
                                {localChat?.debug && localChat.debug.map((value, index) => {
                                    const chatClassname = "cwc-chat-message " + value.type;
                                    const isCelleditable = value.isCode;
                                    const setCode = (val) => { onChangeDebugChatCode(val, index); }
                                    return (
                                        <div key={index} className={chatClassname} style={value.isCode ? { width: "75%" } : {}}>
                                            {!value.isCode ? <pre style={{ textWrap: "wrap" }}>{value.message}</pre> : <CodeEditor code={value.message} setCode={setCode} editable={isCelleditable} />}
                                            {isCelleditable && <>
                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                                    <button className="button-29" onClick={() => copyCode(value.message)}>Copy Code</button>
                                                    <button className="button-29" onClick={() => modifyJupyterNotebook(cwcIndex, value.message)}>Modify Selected Cell</button>
                                                </div>
                                            </>
                                            }
                                        </div>
                                    )
                                })}
                                {localChat?.isLoading && <div className="cwc-chat-message incoming" style={{ padding: '50px', background: "none" }}>
                                    <BounceLoader color="white" size={40} loading={localChat?.isLoading} />
                                </div>
                                }
                            </div>
                        }
                        <div className="cwc-input">
                            <div className="cwc-input-comp custom-scrollbar">
                                <textarea
                                    ref={inputRef}
                                    value={input}
                                    onChange={(e) => { setInput(e.target.value); }}
                                    className="textarea resize-ta custom-scrollbar"
                                    placeholder="Message to modify Code..."
                                    onKeyDown={(e) => handleKeyDown(e)}
                                    disabled={localChat?.isLoading}
                                >
                                </textarea>
                            </div>
                            <div className="cwc-input-send">
                                <button style={{ borderRadius: "10px" }} disabled={input === ""} onClick={() => { onSend() }}>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        className="text-white dark:text-black"><path d="M7 11L12 6L17 11M12 18V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            // transition:Bounce
            />
            {/* React Bootstrap Modal */}
            <Modal
                isOpen={showModal}
                onRequestClose={handleCloseModal}
                contentLabel="System Prompt"
                ariaHideApp={false}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1100,
                    },
                    content: {
                        maxWidth: '800px',
                        margin: 'auto',
                        height: 'auto',
                        maxHeight: '400px',
                    },
                }}
            >
                <h2>
                    System Prompt
                </h2>
                <div >
                    <textarea rows="10" className="modalTextArea" value={systemPrompt} onChange={(e) => { setSystemPrompt(e.target.value) }}></textarea>
                </div>
                <button style={{ margin: '10px' }} onClick={handleCloseModal}>Close Modal</button>
            </Modal>
        </>
    )
}

export default React.memo(ChatWithCode);